import Plugin from 'core/plugins/plugin'
import React from 'react'

const developerPlugin = new Plugin('developer', 'Developer', '/ui/developer')

export default developerPlugin
